import { FC } from 'react';
// MUI
import { Box, Typography } from '@mui/material';
// Icons
import { ErrorOutline as ErrorOutlineIcon } from '@mui/icons-material';

const CampaignUnavailable:FC = () => {
  return (
    <Box sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      p: 4
    }}>
      <ErrorOutlineIcon color="error" sx={{ fontSize: 64, mb: 2 }} />
      <Typography variant="h5" gutterBottom>Registration is not available</Typography>
      <Typography variant="body1" color="text.secondary">This campaign is either inactive or the link is invalid.</Typography>
      <Typography variant="body1" color="text.secondary">Please check the URL or contact support for more details.</Typography>
    </Box>
  );
};

export default CampaignUnavailable;
